var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 ma-0"},[_c('v-row',[_c('div',{staticClass:"custom-grid"},_vm._l((_vm.users),function(author){return _c('author-item',{key:author.username,attrs:{"author":author}})}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }